import { useState, useEffect } from "react";
import { ConnectionStatus, User } from "../../../Interfaces/connections";
import { DropdownItem } from "../../../Interfaces/dropdownInterfaces";
import { getUsers } from "../../../Requests/connections";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import { StaticMultiSelectDropdown } from "../StaticMultiSelectDropdown";

interface Props {
  name: string;
  label: string;
  value?: Array<any>;
  onChange: (name: string, value: Array<any>) => void;
  disabled?: boolean;
  extraLabel?: boolean;
  allDefaultValue?: boolean;
  sensitiveTo?: any;
  withTagBox?: boolean;
  getData?: (sensitiveTo: any) => Promise<User[]>;
  onDataFetch?: (users: User[]) => void;
}

const UsersMultiSelectDropdown = ({
  label,
  name,
  onChange,
  value,
  disabled = false,
  extraLabel,
  allDefaultValue,
  getData,
  sensitiveTo,
  withTagBox,
  onDataFetch,
}: Props) => {
  const [users, setUsers] = useState<User[] | null>(null);

  const fetchUsers = (sensitiveTo: any) => {
    (getData ? getData(sensitiveTo) : getUsers())
      .then((resp) => {
        setUsers(resp);
        if (onDataFetch) onDataFetch(resp);
      })
      .catch(packetErrorHandler);
  };

  useEffect(() => {
    fetchUsers(sensitiveTo);
  }, [sensitiveTo]);

  const getItems = () => {
    if (!users) return [{ id: -1, name: "" }];
    const res: Array<DropdownItem> = [];
    if (users.length)
      users.map((option) => {
        res.push({
          id: option.id,
          name: option.name,
          additional: (
            <div
              className={`w-3 h-3 rounded-full ${
                option.connectionStatus === ConnectionStatus.Disconnected
                  ? "bg-red-700"
                  : null
              } ${
                option.connectionStatus === ConnectionStatus.Offline
                  ? "bg-gray-300"
                  : null
              } ${
                option.connectionStatus === ConnectionStatus.Online
                  ? "bg-green-600"
                  : null
              }`}
            />
          ),
        });
      });
    return res;
  };

  return (
    <StaticMultiSelectDropdown
      extraLabel={extraLabel}
      name={name}
      label={label}
      // className: "mt-3",
      onChange={onChange}
      value={value}
      items={getItems()}
      withSelectAll
      disabled={disabled}
      allDefaultValue={allDefaultValue}
      withTagBox={withTagBox}
    />
  );
};

export default UsersMultiSelectDropdown;
